// Zwischenstopps (eine Fahrt mit Halten zwischen Abholort und Ziel). Flache Schlüssel wie in de.js, wird in fieldMapping.js eingemischt.
const de = {
  wp_via: "über",
  tn_title: "Notizen",
  tn_admin: "Admin",
  tn_user: "Nutzer",
  tn_empty: "Noch keine Notizen.",
  tn_placeholder: "Notiz zur Fahrt …",
  tn_hint: "Sichtbar für Admin, Unternehmen und den Fahrer dieser Fahrt.",
  tn_add: "Notiz hinzufügen",
  tn_delete: "Notiz löschen",
  tn_error: "Notizen konnten nicht geladen/gespeichert werden",
  tn_btn: "Notiz",
  tn_dialog_title: "Notizen zur Fahrt",
  pm_btn: "Als bezahlt markieren",
  pm_undo: "Bezahlt-Markierung zurücknehmen",
  pm_title: "Fahrt als bezahlt markieren",
  pm_hint: "Der nächste Fahrer und das Unternehmen sehen „Bezahlt“ mit diesem Hinweis.",
  pm_note_label: "Hinweis (optional)",
  pm_note_ph: "z. B. Rückfahrt bei der Hinfahrt mitbezahlt",
  pm_confirm: "Als bezahlt markieren",
  pm_close: "Abbrechen",
  pm_marked: "Bezahlt-Hinweis",
  pm_marked_default: "Als bezahlt markiert",
  pm_toast_on: "Fahrt als bezahlt markiert",
  pm_toast_off: "Markierung zurückgenommen",
  pm_error: "Konnte nicht gespeichert werden",
  pm_driver_next: "Rückfahrt wurde bereits mitbezahlt (als bezahlt markieren)",
  wp_fee: "Gebühr für Zwischenstopps",
  wp_driver_route_stop: "Route zum Zwischenstopp",
  wp_driver_reached: "Am Zwischenstopp angekommen",
  wp_driver_toast: "Zwischenstopp erreicht – weiter zum nächsten Ziel",
  wp_title: "Zwischenstopps",
  lang_filter_title: "Fahrersprache",
  lang_filter_any: "Alle Sprachen",
  lang_spoken: "Fahrer sprechen",
  lang_pref_none: "Keine Präferenz",
  driverLanguage: "Fahrer mit Sprache",
  driverLanguageDescription: "Kostenlos: Wir bevorzugen einen Fahrer, der die gewählte Sprache spricht.",
  languages: "Sprachen",
  demo_eyebrow: "So einfach",
  demo_title: "Zwischenstopp und Rückfahrt woanders hin",
  demo_title2: "in 15 Sekunden gebucht.",
  demo_sub: "Adressen eingeben, Stopp hinzufügen, für die Rückfahrt ein anderes Ziel wählen – den Festpreis je Fahrt sehen Sie sofort.",
  demo_s1: "Start und Ziel eingeben",
  demo_s2: "Zwischenstopp hinzufügen",
  demo_s3: "Rückfahrt zu anderer Adresse",
  demo_s4: "Festpreis sehen und buchen",
  demo_book: "Fahrt buchen",
  demo_round: "Hin- & Rückfahrt",
  demo_cta: "Jetzt buchen",
  demo_done: "Gebucht – Bestätigung per E-Mail",
  hp_stops_art: "Route mit Zwischenstopp",
  hp_ret_art: "Hinfahrt und Rückfahrt mit anderer Zieladresse",
  hp_chip_start: "Start",
  hp_chip_stop: "Zwischenstopp",
  hp_chip_dest: "Ziel",
  hp_chip_out: "Hinfahrt",
  hp_chip_ret: "Rückfahrt",
  hp_chip_other: "Andere Zieladresse",
  hp_stops_eyebrow: "Zwischenstopps",
  hp_stops_title: "Unterwegs noch kurz etwas erledigen?",
  hp_stops_title2: "Kein Problem.",
  hp_stops_text: "Apotheke, Hotel oder ein kurzer Abstecher: Fügen Sie Ihrer Fahrt bis zu {n} Zwischenstopps hinzu. Der Fahrer plant die Strecke für Sie, den Preis sehen Sie sofort.",
  hp_stops_b1: "Bis zu {n} Stopps je Fahrt",
  hp_stops_b2: "Für Hinfahrt, Rückfahrt oder beide",
  hp_stops_b3: "Festpreis nach der gesamten Strecke – ohne Überraschungen",
  hp_stops_cta: "Zwischenstopp planen",
  hp_ret_eyebrow: "Hin- & Rückfahrt",
  hp_ret_title: "Zurück woanders hin?",
  hp_ret_title2: "Sie bestimmen.",
  hp_ret_text: "Hinfahrt zum Flughafen, Rückfahrt zu einer anderen Adresse? Mit „Andere Adressen für die Rückfahrt“ legen Sie das Ziel der Rückfahrt frei fest – alles in einer Buchung.",
  hp_ret_b1: "Eigene Zieladresse für die Rückfahrt",
  hp_ret_b2: "Eigener, transparenter Preis je Fahrt",
  hp_ret_b3: "Eine Buchung, eine Zahlung",
  hp_ret_cta: "Rückfahrt planen",
  cs_extras: "Zusatzleistungen",
  cs_data: "Ihre Daten",
  cs_payment: "Zahlung",
  cs_step: "Schritt {n} von {total}",
  cs_next: "Danach",
  cs_aria: "Fortschritt der Buchung",
  returnAfterOutboundError: "Die Rückfahrt muss nach der Hinfahrt liegen.",
  ret_badge: 'Rückfahrt',
  ret_diff_label: 'Andere Adressen für die Rückfahrt',
  ret_diff_hint: 'Die Rückfahrt fährt mit getauschten Adressen (Abholort ↔ Ziel).',
  ret_pickup: "Abholadresse (= Ziel der Hinfahrt)",
  ret_dest: 'Zieladresse',
  ret_pickup_ph: 'Abholadresse der Rückfahrt',
  ret_dest_ph: 'Zieladresse der Rückfahrt',
  ret_price_info: 'Der Preis der Rückfahrt wird nach dieser Strecke berechnet.',
  ret_info_title: 'Rückfahrt mit anderen Adressen',
  wp_mode_out: 'Hinfahrt',
  wp_mode_both: 'Hin- und Rückfahrt',
  wp_mode_ret: 'Rückfahrt',
  wp_mode_out_short: "Hin",
  wp_mode_both_short: "Beide",
  wp_mode_ret_short: "Zurück",
  wp_mode_aria: 'Gilt für welche Fahrt',
  wp_hint_round: 'Reihenfolge: Abholort → Zwischenstopp → Ziel. Auf dem Rückweg gilt die Liste in umgekehrter Reihenfolge. Der Preis richtet sich nach der gesamten Strecke.',
  wp_title_out: "Zwischenstopps Hinfahrt",
  wp_title_ret: "Zwischenstopps Rückfahrt",
  extras_step_out: "Nur für Ihre Hinfahrt. Danach wählen Sie die Zusatzleistungen der Rückfahrt.",
  extras_step_ret: "Nur für Ihre Rückfahrt.",
  wp_label: "Zwischenstopp",
  wp_add: "Zwischenstopp hinzufügen",
  wp_remove: "Zwischenstopp entfernen",
  wp_placeholder: "Adresse des Zwischenstopps",
  wp_hint: "Reihenfolge: Abholort → Zwischenstopp → Ziel. Der Preis richtet sich nach der gesamten Strecke.",
  wp_enter_error: "Bitte Adresse des Zwischenstopps eingeben.",
  wp_select_error: "Bitte Adresse des Zwischenstopps aus der Liste wählen.",
  wp_count_one: "1 Zwischenstopp",
  wp_count_many: "{n} Zwischenstopps",
  wp_route: "Strecke",
  wp_pickup: "Abholort",
  wp_destination: "Ziel",
  wp_total: "Gesamtstrecke",
};
const en = {
  wp_via: "via",
  tn_title: "Notes",
  tn_admin: "Admin",
  tn_user: "User",
  tn_empty: "No notes yet.",
  tn_placeholder: "Note about this trip …",
  tn_hint: "Visible to admin, company and the driver of this trip.",
  tn_add: "Add note",
  tn_delete: "Delete note",
  tn_error: "Notes could not be loaded/saved",
  tn_btn: "Note",
  tn_dialog_title: "Trip notes",
  pm_btn: "Mark as paid",
  pm_undo: "Undo paid mark",
  pm_title: "Mark trip as paid",
  pm_hint: "The next driver and the company will see “Paid” with this note.",
  pm_note_label: "Note (optional)",
  pm_note_ph: "e.g. return trip already paid with the outbound trip",
  pm_confirm: "Mark as paid",
  pm_close: "Cancel",
  pm_marked: "Payment note",
  pm_marked_default: "Marked as paid",
  pm_toast_on: "Trip marked as paid",
  pm_toast_off: "Mark removed",
  pm_error: "Could not be saved",
  pm_driver_next: "Return trip has already been paid (mark as paid)",
  wp_fee: "Stopover fee",
  wp_driver_route_stop: "Route to stopover",
  wp_driver_reached: "Arrived at stopover",
  wp_driver_toast: "Stopover reached – continue to the next destination",
  wp_title: "Stopovers",
  lang_filter_title: "Driver language",
  lang_filter_any: "All languages",
  lang_spoken: "Drivers speak",
  lang_pref_none: "No preference",
  driverLanguage: "Driver with language",
  driverLanguageDescription: "Free: we prefer a driver who speaks the chosen language.",
  languages: "Languages",
  demo_eyebrow: "So easy",
  demo_title: "Stopover and a different return destination",
  demo_title2: "booked in 15 seconds.",
  demo_sub: "Enter addresses, add a stop, choose another destination for the return – you see the fixed price per trip right away.",
  demo_s1: "Enter start and destination",
  demo_s2: "Add a stopover",
  demo_s3: "Return to a different address",
  demo_s4: "See the fixed price and book",
  demo_book: "Book a trip",
  demo_round: "Outbound & return",
  demo_cta: "Book now",
  demo_done: "Booked – confirmation by email",
  hp_stops_art: "Route with a stopover",
  hp_ret_art: "Outbound and return trip with a different destination",
  hp_chip_start: "Start",
  hp_chip_stop: "Stopover",
  hp_chip_dest: "Destination",
  hp_chip_out: "Outbound",
  hp_chip_ret: "Return",
  hp_chip_other: "Different destination",
  hp_stops_eyebrow: "Stopovers",
  hp_stops_title: "Need to run a quick errand on the way?",
  hp_stops_title2: "No problem.",
  hp_stops_text: "Pharmacy, hotel or a short detour: add up to {n} stopovers to your trip. The driver plans the route for you and you see the price right away.",
  hp_stops_b1: "Up to {n} stops per trip",
  hp_stops_b2: "For outbound, return or both",
  hp_stops_b3: "Fixed price for the whole route – no surprises",
  hp_stops_cta: "Plan a stopover",
  hp_ret_eyebrow: "Outbound & return",
  hp_ret_title: "Going back somewhere else?",
  hp_ret_title2: "You decide.",
  hp_ret_text: "To the airport and back to a different address? With “Different addresses for the return trip” you choose the return destination freely – all in one booking.",
  hp_ret_b1: "Own destination for the return trip",
  hp_ret_b2: "Own, transparent price per trip",
  hp_ret_b3: "One booking, one payment",
  hp_ret_cta: "Plan the return trip",
  cs_extras: "Extras",
  cs_data: "Your details",
  cs_payment: "Payment",
  cs_step: "Step {n} of {total}",
  cs_next: "Next",
  cs_aria: "Booking progress",
  returnAfterOutboundError: "The return trip must be after the outbound trip.",
  ret_badge: 'Return',
  ret_diff_label: 'Different addresses for the return trip',
  ret_diff_hint: 'The return trip uses the swapped addresses (pickup ↔ destination).',
  ret_pickup: "Pickup address (= destination of the outbound trip)",
  ret_dest: 'Destination address',
  ret_pickup_ph: 'Pickup address of the return trip',
  ret_dest_ph: 'Destination address of the return trip',
  ret_price_info: 'The price of the return trip is calculated for this route.',
  ret_info_title: 'Return trip with different addresses',
  wp_mode_out: 'Outbound',
  wp_mode_both: 'Outbound and return',
  wp_mode_ret: 'Return',
  wp_mode_out_short: "Out",
  wp_mode_both_short: "Both",
  wp_mode_ret_short: "Back",
  wp_mode_aria: 'Which trip this applies to',
  wp_hint_round: 'Order: pickup → stopover → destination. On the way back the list applies in reverse order. The price depends on the whole route.',
  wp_title_out: "Stopovers outbound",
  wp_title_ret: "Stopovers return",
  extras_step_out: "Only for your outbound trip. Next you choose the extras for the return trip.",
  extras_step_ret: "Only for your return trip.",
  wp_label: "Stopover",
  wp_add: "Add stopover",
  wp_remove: "Remove stopover",
  wp_placeholder: "Address of the stopover",
  wp_hint: "Order: pickup → stopover → destination. The price is based on the total route.",
  wp_enter_error: "Please enter the stopover address.",
  wp_select_error: "Please select the stopover address from the list.",
  wp_count_one: "1 stopover",
  wp_count_many: "{n} stopovers",
  wp_route: "Route",
  wp_pickup: "Pickup",
  wp_destination: "Destination",
  wp_total: "Total distance",
};
const tr = {
  wp_via: "üzerinden",
  tn_title: "Notlar",
  tn_admin: "Yönetici",
  tn_user: "Kullanıcı",
  tn_empty: "Henüz not yok.",
  tn_placeholder: "Yolculuk notu …",
  tn_hint: "Yönetici, şirket ve bu yolculuğun sürücüsü görebilir.",
  tn_add: "Not ekle",
  tn_delete: "Notu sil",
  tn_error: "Notlar yüklenemedi/kaydedilemedi",
  tn_btn: "Not",
  tn_dialog_title: "Yolculuk notları",
  pm_btn: "Ödendi olarak işaretle",
  pm_undo: "Ödendi işaretini geri al",
  pm_title: "Yolculuğu ödendi olarak işaretle",
  pm_hint: "Sonraki sürücü ve şirket bu notla “Ödendi” görür.",
  pm_note_label: "Not (isteğe bağlı)",
  pm_note_ph: "örn. dönüş yolculuğu gidişte ödendi",
  pm_confirm: "Ödendi olarak işaretle",
  pm_close: "İptal",
  pm_marked: "Ödeme notu",
  pm_marked_default: "Ödendi olarak işaretlendi",
  pm_toast_on: "Yolculuk ödendi olarak işaretlendi",
  pm_toast_off: "İşaret kaldırıldı",
  pm_error: "Kaydedilemedi",
  pm_driver_next: "Dönüş yolculuğu zaten ödendi (ödendi olarak işaretle)",
  wp_fee: "Ara durak ücreti",
  wp_driver_route_stop: "Ara durağa rota",
  wp_driver_reached: "Ara durağa varıldı",
  wp_driver_toast: "Ara durağa varıldı – sonraki hedefe devam",
  wp_title: "Ara duraklar",
  lang_filter_title: "Sürücü dili",
  lang_filter_any: "Tüm diller",
  lang_spoken: "Sürücüler konuşur",
  lang_pref_none: "Tercih yok",
  driverLanguage: "Dil bilen sürücü",
  driverLanguageDescription: "Ücretsiz: Seçtiğiniz dili konuşan bir sürücüyü tercih ederiz.",
  languages: "Diller",
  demo_eyebrow: "Çok kolay",
  demo_title: "Ara durak ve dönüşte başka bir yer",
  demo_title2: "15 saniyede rezerve edildi.",
  demo_sub: "Adresleri girin, durak ekleyin, dönüş için başka bir varış yeri seçin – yolculuk başına sabit fiyatı hemen görürsünüz.",
  demo_s1: "Başlangıç ve varışı girin",
  demo_s2: "Ara durak ekleyin",
  demo_s3: "Dönüş başka bir adrese",
  demo_s4: "Sabit fiyatı görün ve rezerve edin",
  demo_book: "Yolculuk rezerve et",
  demo_round: "Gidiş & dönüş",
  demo_cta: "Şimdi rezerve et",
  demo_done: "Rezerve edildi – e-posta ile onay",
  hp_stops_art: "Ara duraklı güzergâh",
  hp_ret_art: "Farklı varış yerli gidiş ve dönüş",
  hp_chip_start: "Başlangıç",
  hp_chip_stop: "Ara durak",
  hp_chip_dest: "Varış",
  hp_chip_out: "Gidiş",
  hp_chip_ret: "Dönüş",
  hp_chip_other: "Farklı varış yeri",
  hp_stops_eyebrow: "Ara duraklar",
  hp_stops_title: "Yolda kısa bir işiniz mi var?",
  hp_stops_title2: "Sorun değil.",
  hp_stops_text: "Eczane, otel veya kısa bir mola: Yolculuğunuza {n} adede kadar ara durak ekleyin. Sürücü güzergâhı sizin için planlar, fiyatı hemen görürsünüz.",
  hp_stops_b1: "Yolculuk başına {n} durağa kadar",
  hp_stops_b2: "Gidiş, dönüş veya ikisi için",
  hp_stops_b3: "Tüm güzergâha göre sabit fiyat – sürpriz yok",
  hp_stops_cta: "Ara durak planla",
  hp_ret_eyebrow: "Gidiş & dönüş",
  hp_ret_title: "Dönüş başka yere mi?",
  hp_ret_title2: "Siz belirleyin.",
  hp_ret_text: "Havalimanına gidiş, dönüş başka bir adrese mi? „Dönüş için farklı adresler“ ile dönüşün varış yerini serbestçe seçersiniz – hepsi tek rezervasyonda.",
  hp_ret_b1: "Dönüş için kendi varış adresi",
  hp_ret_b2: "Yolculuk başına şeffaf fiyat",
  hp_ret_b3: "Tek rezervasyon, tek ödeme",
  hp_ret_cta: "Dönüşü planla",
  cs_extras: "Ek hizmetler",
  cs_data: "Bilgileriniz",
  cs_payment: "Ödeme",
  cs_step: "Adım {n} / {total}",
  cs_next: "Sonraki",
  cs_aria: "Rezervasyon ilerlemesi",
  returnAfterOutboundError: "Dönüş, gidişten sonra olmalıdır.",
  ret_badge: 'Dönüş',
  ret_diff_label: 'Dönüş için farklı adresler',
  ret_diff_hint: 'Dönüş yolculuğu yer değiştirmiş adreslerle yapılır (alış yeri ↔ varış).',
  ret_pickup: "Alış adresi (= gidişin varış yeri)",
  ret_dest: 'Varış adresi',
  ret_pickup_ph: 'Dönüşün alış adresi',
  ret_dest_ph: 'Dönüşün varış adresi',
  ret_price_info: 'Dönüş fiyatı bu güzergâha göre hesaplanır.',
  ret_info_title: 'Farklı adresli dönüş',
  wp_mode_out: 'Gidiş',
  wp_mode_both: 'Gidiş ve dönüş',
  wp_mode_ret: 'Dönüş',
  wp_mode_out_short: "Gidiş",
  wp_mode_both_short: "İkisi",
  wp_mode_ret_short: "Dönüş",
  wp_mode_aria: 'Hangi yolculuk için geçerli',
  wp_hint_round: 'Sıra: alış yeri → ara durak → varış. Dönüşte liste ters sırayla geçerlidir. Fiyat tüm güzergâha göre belirlenir.',
  wp_title_out: "Gidiş ara durakları",
  wp_title_ret: "Dönüş ara durakları",
  extras_step_out: "Yalnızca gidiş için. Ardından dönüş için seçersiniz.",
  extras_step_ret: "Yalnızca dönüş için.",
  wp_label: "Ara durak",
  wp_add: "Ara durak ekle",
  wp_remove: "Ara durağı kaldır",
  wp_placeholder: "Ara durağın adresi",
  wp_hint: "Sıra: alış noktası → ara durak → varış. Fiyat toplam mesafeye göre hesaplanır.",
  wp_enter_error: "Lütfen ara durağın adresini girin.",
  wp_select_error: "Lütfen ara durağın adresini listeden seçin.",
  wp_count_one: "1 ara durak",
  wp_count_many: "{n} ara durak",
  wp_route: "Güzergâh",
  wp_pickup: "Alış noktası",
  wp_destination: "Varış",
  wp_total: "Toplam mesafe",
};
const pl = {
  wp_via: "przez",
  tn_title: "Notatki",
  tn_admin: "Admin",
  tn_user: "Użytkownik",
  tn_empty: "Brak notatek.",
  tn_placeholder: "Notatka do przejazdu …",
  tn_hint: "Widoczne dla admina, firmy i kierowcy tego przejazdu.",
  tn_add: "Dodaj notatkę",
  tn_delete: "Usuń notatkę",
  tn_error: "Nie udało się wczytać/zapisać notatek",
  tn_btn: "Notatka",
  tn_dialog_title: "Notatki do przejazdu",
  pm_btn: "Oznacz jako opłacone",
  pm_undo: "Cofnij oznaczenie",
  pm_title: "Oznacz przejazd jako opłacony",
  pm_hint: "Następny kierowca i firma zobaczą „Opłacone” z tą uwagą.",
  pm_note_label: "Uwaga (opcjonalnie)",
  pm_note_ph: "np. przejazd powrotny opłacony przy przejeździe tam",
  pm_confirm: "Oznacz jako opłacone",
  pm_close: "Anuluj",
  pm_marked: "Uwaga o płatności",
  pm_marked_default: "Oznaczono jako opłacone",
  pm_toast_on: "Przejazd oznaczono jako opłacony",
  pm_toast_off: "Oznaczenie cofnięte",
  pm_error: "Nie udało się zapisać",
  pm_driver_next: "Przejazd powrotny został już opłacony (oznacz jako opłacone)",
  wp_fee: "Opłata za przystanki pośrednie",
  wp_driver_route_stop: "Trasa do przystanku",
  wp_driver_reached: "Dojechano do przystanku",
  wp_driver_toast: "Przystanek osiągnięty – dalej do następnego celu",
  wp_title: "Przystanki pośrednie",
  lang_filter_title: "Język kierowcy",
  lang_filter_any: "Wszystkie języki",
  lang_spoken: "Kierowcy mówią",
  lang_pref_none: "Bez preferencji",
  driverLanguage: "Kierowca z językiem",
  driverLanguageDescription: "Bezpłatnie: preferujemy kierowcę mówiącego w wybranym języku.",
  languages: "Języki",
  demo_eyebrow: "Tak łatwo",
  demo_title: "Przystanek i powrót w inne miejsce",
  demo_title2: "zarezerwowane w 15 sekund.",
  demo_sub: "Wpisz adresy, dodaj przystanek, wybierz inny cel powrotu – stałą cenę za przejazd widzisz od razu.",
  demo_s1: "Wpisz start i cel",
  demo_s2: "Dodaj przystanek",
  demo_s3: "Powrót pod inny adres",
  demo_s4: "Zobacz stałą cenę i zarezerwuj",
  demo_book: "Zarezerwuj przejazd",
  demo_round: "Tam i z powrotem",
  demo_cta: "Zarezerwuj",
  demo_done: "Zarezerwowano – potwierdzenie e-mailem",
  hp_stops_art: "Trasa z przystankiem",
  hp_ret_art: "Przejazd tam i z powrotem z innym celem",
  hp_chip_start: "Start",
  hp_chip_stop: "Przystanek",
  hp_chip_dest: "Cel",
  hp_chip_out: "Tam",
  hp_chip_ret: "Powrót",
  hp_chip_other: "Inny cel",
  hp_stops_eyebrow: "Przystanki",
  hp_stops_title: "Coś do załatwienia po drodze?",
  hp_stops_title2: "Nie ma problemu.",
  hp_stops_text: "Apteka, hotel lub krótki objazd: dodaj do przejazdu do {n} przystanków. Kierowca zaplanuje trasę, a cenę widzisz od razu.",
  hp_stops_b1: "Do {n} przystanków na przejazd",
  hp_stops_b2: "Dla przejazdu tam, powrotu lub obu",
  hp_stops_b3: "Stała cena za całą trasę – bez niespodzianek",
  hp_stops_cta: "Zaplanuj przystanek",
  hp_ret_eyebrow: "Tam i z powrotem",
  hp_ret_title: "Wracasz gdzie indziej?",
  hp_ret_title2: "Ty decydujesz.",
  hp_ret_text: "Na lotnisko i z powrotem pod inny adres? Dzięki „Inne adresy dla przejazdu powrotnego” swobodnie wybierasz cel powrotu – wszystko w jednej rezerwacji.",
  hp_ret_b1: "Własny adres docelowy powrotu",
  hp_ret_b2: "Własna, przejrzysta cena za przejazd",
  hp_ret_b3: "Jedna rezerwacja, jedna płatność",
  hp_ret_cta: "Zaplanuj powrót",
  cs_extras: "Usługi dodatkowe",
  cs_data: "Twoje dane",
  cs_payment: "Płatność",
  cs_step: "Krok {n} z {total}",
  cs_next: "Następnie",
  cs_aria: "Postęp rezerwacji",
  returnAfterOutboundError: "Przejazd powrotny musi być po przejeździe tam.",
  ret_badge: 'Powrót',
  ret_diff_label: 'Inne adresy dla przejazdu powrotnego',
  ret_diff_hint: 'Przejazd powrotny odbywa się z zamienionymi adresami (odbiór ↔ cel).',
  ret_pickup: "Adres odbioru (= cel przejazdu tam)",
  ret_dest: 'Adres docelowy',
  ret_pickup_ph: 'Adres odbioru przy powrocie',
  ret_dest_ph: 'Adres docelowy przy powrocie',
  ret_price_info: 'Cena przejazdu powrotnego jest liczona dla tej trasy.',
  ret_info_title: 'Powrót z innymi adresami',
  wp_mode_out: 'Przejazd tam',
  wp_mode_both: 'Tam i z powrotem',
  wp_mode_ret: 'Przejazd powrotny',
  wp_mode_out_short: "Tam",
  wp_mode_both_short: "Oba",
  wp_mode_ret_short: "Powrót",
  wp_mode_aria: 'Dla którego przejazdu',
  wp_hint_round: 'Kolejność: odbiór → przystanek → cel. W drodze powrotnej lista obowiązuje w odwrotnej kolejności. Cena zależy od całej trasy.',
  wp_title_out: "Przystanki w drodze tam",
  wp_title_ret: "Przystanki w drodze powrotnej",
  extras_step_out: "Tylko dla przejazdu tam. Potem wybierzesz usługi dla powrotu.",
  extras_step_ret: "Tylko dla przejazdu powrotnego.",
  wp_label: "Przystanek pośredni",
  wp_add: "Dodaj przystanek pośredni",
  wp_remove: "Usuń przystanek pośredni",
  wp_placeholder: "Adres przystanku pośredniego",
  wp_hint: "Kolejność: miejsce odbioru → przystanek → cel. Cena zależy od całej trasy.",
  wp_enter_error: "Podaj adres przystanku pośredniego.",
  wp_select_error: "Wybierz adres przystanku pośredniego z listy.",
  wp_count_one: "1 przystanek pośredni",
  wp_count_many: "Przystanki pośrednie: {n}",
  wp_route: "Trasa",
  wp_pickup: "Miejsce odbioru",
  wp_destination: "Cel",
  wp_total: "Cała trasa",
};
const uk = {
  wp_via: "через",
  tn_title: "Нотатки",
  tn_admin: "Адмін",
  tn_user: "Користувач",
  tn_empty: "Нотаток ще немає.",
  tn_placeholder: "Нотатка до поїздки …",
  tn_hint: "Бачать адмін, компанія та водій цієї поїздки.",
  tn_add: "Додати нотатку",
  tn_delete: "Видалити нотатку",
  tn_error: "Не вдалося завантажити/зберегти нотатки",
  tn_btn: "Нотатка",
  tn_dialog_title: "Нотатки до поїздки",
  pm_btn: "Позначити як оплачене",
  pm_undo: "Скасувати позначку",
  pm_title: "Позначити поїздку як оплачену",
  pm_hint: "Наступний водій і компанія побачать «Оплачено» з цією приміткою.",
  pm_note_label: "Примітка (необов’язково)",
  pm_note_ph: "напр. зворотна поїздка оплачена під час поїздки туди",
  pm_confirm: "Позначити як оплачене",
  pm_close: "Скасувати",
  pm_marked: "Примітка про оплату",
  pm_marked_default: "Позначено як оплачене",
  pm_toast_on: "Поїздку позначено як оплачену",
  pm_toast_off: "Позначку скасовано",
  pm_error: "Не вдалося зберегти",
  pm_driver_next: "Зворотну поїздку вже оплачено (позначити як оплачене)",
  wp_fee: "Плата за проміжні зупинки",
  wp_driver_route_stop: "Маршрут до зупинки",
  wp_driver_reached: "Прибули на зупинку",
  wp_driver_toast: "Зупинка досягнута – далі до наступного пункту",
  wp_title: "Проміжні зупинки",
  lang_filter_title: "Мова водія",
  lang_filter_any: "Усі мови",
  lang_spoken: "Водії розмовляють",
  lang_pref_none: "Без переваг",
  driverLanguage: "Водій з мовою",
  driverLanguageDescription: "Безкоштовно: ми надаємо перевагу водію, який розмовляє обраною мовою.",
  languages: "Мови",
  demo_eyebrow: "Так просто",
  demo_title: "Зупинка і повернення в інше місце",
  demo_title2: "заброньовано за 15 секунд.",
  demo_sub: "Введіть адреси, додайте зупинку, оберіть інший пункт для повернення – фіксовану ціну за поїздку видно одразу.",
  demo_s1: "Введіть старт і пункт призначення",
  demo_s2: "Додайте зупинку",
  demo_s3: "Повернення на іншу адресу",
  demo_s4: "Побачте фіксовану ціну та забронюйте",
  demo_book: "Забронювати поїздку",
  demo_round: "Туди й назад",
  demo_cta: "Забронювати",
  demo_done: "Заброньовано – підтвердження на e-mail",
  hp_stops_art: "Маршрут із зупинкою",
  hp_ret_art: "Поїздка туди й назад з іншим пунктом призначення",
  hp_chip_start: "Старт",
  hp_chip_stop: "Зупинка",
  hp_chip_dest: "Пункт призначення",
  hp_chip_out: "Туди",
  hp_chip_ret: "Назад",
  hp_chip_other: "Інший пункт призначення",
  hp_stops_eyebrow: "Зупинки",
  hp_stops_title: "Треба щось зробити по дорозі?",
  hp_stops_title2: "Без проблем.",
  hp_stops_text: "Аптека, готель чи короткий об'їзд: додайте до поїздки до {n} зупинок. Водій спланує маршрут, а ціну ви бачите одразу.",
  hp_stops_b1: "До {n} зупинок за поїздку",
  hp_stops_b2: "Для поїздки туди, назад або обох",
  hp_stops_b3: "Фіксована ціна за весь маршрут – без сюрпризів",
  hp_stops_cta: "Спланувати зупинку",
  hp_ret_eyebrow: "Туди й назад",
  hp_ret_title: "Назад в інше місце?",
  hp_ret_title2: "Вирішуєте ви.",
  hp_ret_text: "В аеропорт, а назад на іншу адресу? З «Іншими адресами для зворотної поїздки» ви вільно обираєте пункт призначення – усе в одному бронюванні.",
  hp_ret_b1: "Власна адреса призначення для зворотної поїздки",
  hp_ret_b2: "Власна прозора ціна за поїздку",
  hp_ret_b3: "Одне бронювання, одна оплата",
  hp_ret_cta: "Спланувати зворотну поїздку",
  cs_extras: "Додаткові послуги",
  cs_data: "Ваші дані",
  cs_payment: "Оплата",
  cs_step: "Крок {n} з {total}",
  cs_next: "Далі",
  cs_aria: "Хід бронювання",
  returnAfterOutboundError: "Зворотна поїздка має бути після поїздки туди.",
  ret_badge: 'Назад',
  ret_diff_label: 'Інші адреси для зворотної поїздки',
  ret_diff_hint: 'Зворотна поїздка їде за поміняними адресами (посадка ↔ призначення).',
  ret_pickup: "Адреса посадки (= пункт призначення поїздки туди)",
  ret_dest: 'Адреса призначення',
  ret_pickup_ph: 'Адреса посадки для зворотної поїздки',
  ret_dest_ph: 'Адреса призначення для зворотної поїздки',
  ret_price_info: 'Ціна зворотної поїздки розраховується за цим маршрутом.',
  ret_info_title: 'Зворотна поїздка з іншими адресами',
  wp_mode_out: 'Поїздка туди',
  wp_mode_both: 'Туди й назад',
  wp_mode_ret: 'Поїздка назад',
  wp_mode_out_short: "Туди",
  wp_mode_both_short: "Обидва",
  wp_mode_ret_short: "Назад",
  wp_mode_aria: 'Для якої поїздки',
  wp_hint_round: 'Порядок: посадка → зупинка → пункт призначення. Дорогою назад список діє у зворотному порядку. Ціна залежить від усього маршруту.',
  wp_title_out: "Зупинки туди",
  wp_title_ret: "Зупинки назад",
  extras_step_out: "Лише для поїздки туди. Потім виберете для зворотної.",
  extras_step_ret: "Лише для зворотної поїздки.",
  wp_label: "Проміжна зупинка",
  wp_add: "Додати проміжну зупинку",
  wp_remove: "Видалити проміжну зупинку",
  wp_placeholder: "Адреса проміжної зупинки",
  wp_hint: "Порядок: місце посадки → зупинка → пункт призначення. Ціна залежить від усього маршруту.",
  wp_enter_error: "Введіть адресу проміжної зупинки.",
  wp_select_error: "Виберіть адресу проміжної зупинки зі списку.",
  wp_count_one: "1 проміжна зупинка",
  wp_count_many: "Проміжних зупинок: {n}",
  wp_route: "Маршрут",
  wp_pickup: "Місце посадки",
  wp_destination: "Пункт призначення",
  wp_total: "Весь маршрут",
};
const all = { de, en, tr, pl, uk };
export default all;
